module.exports = __webpack_public_path__ + "static/media/DENT_LOGO.2d9787af.png";